webpackJsonp([103657926474580],{

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.testimonialQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\tpadding: 10px 25px;\n"], ["\n\tpadding: 10px 25px;\n"]);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(17);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledFlexComponent = __webpack_require__(23);
	
	var _styledFlexComponent2 = _interopRequireDefault(_styledFlexComponent);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Typography = __webpack_require__(18);
	
	var _evergreenUi = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TestimonialRoll = function (_Component) {
		_inherits(TestimonialRoll, _Component);
	
		function TestimonialRoll() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, TestimonialRoll);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				letterDialogIsShown: false,
				letterContents: {},
				title: ""
			}, _this.showFullLetter = function (sizes, title) {
				_this.setState({ letterDialogIsShown: true, letterContents: sizes, letterTitle: title });
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		TestimonialRoll.prototype.render = function render() {
			var _this2 = this;
	
			var testimonials = this.props.data.allMarkdownRemark.edges;
			var index = this.props.data.PDFtestimonies.frontmatter;
	
			return _react2.default.createElement(
				RollContainer,
				null,
				_react2.default.createElement(_reactHelmet2.default, { title: index.title }),
				_react2.default.createElement(
					_Typography.CenteredFull,
					null,
					_react2.default.createElement(
						_Typography.Title,
						null,
						index.title
					)
				),
				_react2.default.createElement(
					_evergreenUi.Heading,
					{ marginBottom: 25 },
					"Letters of Recommendation"
				),
				_react2.default.createElement(
					PDFGrid,
					null,
					index.pdfs.map(function (pdf) {
						return _react2.default.createElement(
							_evergreenUi.Card,
							{
								backgroundColor: "white",
								key: pdf.src.id,
								onClick: function onClick() {
									return _this2.showFullLetter(pdf.src.childImageSharp.sizes, pdf.title);
								},
								padding: 10,
								elevation: 1,
								hoverElevation: 3 },
							_react2.default.createElement(_gatsbyImage2.default, { sizes: pdf.src.childImageSharp.sizes }),
							_react2.default.createElement(
								_evergreenUi.Text,
								{ size: 500 },
								pdf.title
							)
						);
					})
				),
				_react2.default.createElement(
					TestimonialGrid,
					null,
					testimonials.map(function (testimonial) {
						return _react2.default.createElement(
							TestimonialCard,
							{ appearance: "tint3" },
							_react2.default.createElement(
								_evergreenUi.Heading,
								{ fontFamily: "Bitter", marginBottom: 50, size: 800 },
								testimonial.node.frontmatter.title
							),
							_react2.default.createElement(_evergreenUi.Paragraph, { dangerouslySetInnerHTML: { __html: testimonial.node.html } }),
							_react2.default.createElement(
								_evergreenUi.Strong,
								{ marginTop: 25, float: "right" },
								testimonial.node.frontmatter.name,
								testimonial.node.frontmatter.location && " \u2022 " + testimonial.node.frontmatter.location,
								testimonial.node.frontmatter.date && " \u2022 " + testimonial.node.frontmatter.date
							)
						);
					})
				),
				_react2.default.createElement(
					_evergreenUi.Dialog,
					{
						onCloseComplete: function onCloseComplete() {
							return _this2.setState({ letterDialogIsShown: false });
						},
						title: this.state.letterTitle,
						hasFooter: false,
						isShown: this.state.letterDialogIsShown },
					_react2.default.createElement(_gatsbyImage2.default, { sizes: this.state.letterContents })
				)
			);
		};
	
		return TestimonialRoll;
	}(_react.Component);
	
	exports.default = TestimonialRoll;
	
	
	var TestimonialCard = (0, _styledComponents2.default)(_evergreenUi.Card).withConfig({
		displayName: "testimonials-page__TestimonialCard"
	})(["padding:3rem 4rem;@media screen and (max-width:800px){padding:2rem;}"]);
	
	var PDFGrid = _styledComponents2.default.div.withConfig({
		displayName: "testimonials-page__PDFGrid"
	})(["display:grid;grid-template-columns:repeat(auto-fill,250px);grid-gap:2rem;text-align:center;margin-bottom:4rem;@media screen and (max-width:768px){grid-template-columns:repeat(auto-fill,150px);}"]);
	
	var RollContainer = _styledComponents2.default.div.withConfig({
		displayName: "testimonials-page__RollContainer"
	})(["margin:", "vw auto;max-width:1200px;blockquote{margin:0;}@media screen and (max-width:1400px){padding:0 ", "vw;}@media screen and (max-width:800px){margin:", "vw auto;}"], 100 / 24, 100 / 24, 100 / 24);
	
	var BlogTags = _styledComponents2.default.div.withConfig({
		displayName: "testimonials-page__BlogTags"
	})(["display:flex;grid-gap:5px;grid-template-columns:1fr;margin:0.5rem 0;strong:not(:first-child){margin-left:5px;}"]);
	
	var TestimonialGrid = _styledComponents2.default.div.withConfig({
		displayName: "testimonials-page__TestimonialGrid"
	})(["display:grid;grid-template-columns:repeat(auto-fit,1fr);grid-gap:25px;@media screen and (max-width:600px){grid-template-columns:repeat(auto-fit,1fr);grid-gap:15px;}"]);
	
	var BlogFlex = _styledFlexComponent2.default.extend(_templateObject);
	
	var BlogImage = (0, _styledComponents2.default)(_gatsbyImage2.default).withConfig({
		displayName: "testimonials-page__BlogImage"
	})(["margin-right:15px;border-radius:10px;"]);
	
	var testimonialQuery = exports.testimonialQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-testimonials-page-jsx-6b2975b5af8c65d4d9f6.js